
export default {
  name: 'Menu',
  components: {
  },
  computed: {

  },
  props: {
    openMenu: Boolean
  },
  data () {
    return {
      year: (new Date()).getFullYear()
    }
  },
  methods: {
  }
}
